import React, { Component } from 'react';
import Grid from 'material-ui/Grid';

import Button from '../../common/Button';
import CorePanel from '../../common/MaterialPanel/Core';
import CopperPanel from '../../common/MaterialPanel/Copper';
import PrepregPanel from '../../common/MaterialPanel/Prepreg';
import { CORE, PREPREG, COPPER } from '../../../constants/globals';
import { Core, Copper, Prepreg } from '../../../models';
import AddWhere from './AddWhere';
import propTypes from './propTypes';

const BOTH_SIDE = 'BOTH SIDE';
const TOP = 'TOP';
const BOTTOM = 'BOTTON';
const NONE = 'NONE';

function addWhere(addTo) {
  if (addTo.top && addTo.bottom) {
    return BOTH_SIDE;
  } else if (addTo.top) {
    return TOP;
  } else if (addTo.bottom) {
    return BOTTOM;
  } else {
    return NONE;
  }
}

export class AddLayerForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      addTo: {
        top: true,
        bottom: false,
      },
      expanded: null,
    };
    this.handleCorePanelToggle =  this.handlePanelToggle(CORE).bind(this);
    this.handlePrepregPanelToggle = this.handlePanelToggle(PREPREG).bind(this);
    this.handleCopperPanelToggle = this.handlePanelToggle(COPPER).bind(this);
    this.onWhereChange = this.onWhereChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.handleAdd.bind(this);
  }

  onWhereChange(event, checked) {
    const { addTo } = this.state;
    const newAddTo = Object.assign(addTo, checked)
    this.setState({ addTo: newAddTo })
  }

  handlePanelToggle(panel) {
    return function(event, expanded){
      this.setState({
        expanded: expanded ? panel : false,
      })
    }
  }

  handleCancel() {
    const { onClose } = this.props;
    onClose();
  }

  handleAdd() {
    const { onClose, core, prepreg, copper } = this.props;
    const { addTo } = this.state;
    let positions = [];

    // TODO: positions need to be searched and calculated once shild and mask
    // are added to outer copper layer
    if (addTo.top) {
      positions.push(1);
    }
    if (addTo.bottom) {
      // -1 is the last index of the array and it points to outer copper
      positions.push(-1);
    }

    onClose({ core, prepreg, copper, positions });
  }

  render() {
    const {
      core,
      copper,
      prepreg,
      lengthUnit
    } = this.props;
    const { expanded, addTo } = this.state;

    const disableButton = !(addTo.bottom || addTo.top);
    const submitLabel = `Add to ${addWhere(addTo)}`;

    const coreMaterial = new Core(core);
    const prepregMaterial = new Prepreg([prepreg]);
    const copperMaterial = new Copper(copper);

    return (
      <form
        id="add-layer"
        noValidate
        autoComplete="off"
        onSubmit={this.onSubmit}
        ref={(form) => this.form = form}
      >
        <CorePanel
          material={coreMaterial}
          expanded={expanded === CORE}
          onToggle={this.handleCorePanelToggle}
          lengthUnit={lengthUnit}
        />
        <PrepregPanel
          material={prepregMaterial}
          expanded={expanded === PREPREG}
          onToggle={this.handlePrepregPanelToggle}
          lengthUnit={lengthUnit}
        />
        <CopperPanel
          material={copperMaterial}
          expanded={expanded === COPPER}
          onToggle={this.handleCopperPanelToggle}
          lengthUnit={lengthUnit}
        />
        <AddWhere
          onChange={this.onWhereChange}
          addTo={addTo}
        />
        <Grid container justify="flex-end">
          <Button
            default
            type="button"
            variant="raised"
            onClick={this.handleCancel}
            label="Cancel"
          />
          <Button
            primary
            type="submit"
            variant="raised"
            label={submitLabel}
            disabled={disableButton}
          >
            Add To
            {addWhere(addTo)}
          </Button>
        </Grid>
      </form>
    );
  }
}

AddLayerForm.propTypes = propTypes; 

export default AddLayerForm;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/AddLayer/AddLayerForm.js